import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button, Col, Form } from 'react-bootstrap';
import { billingImportJobs, modals } from 'ducks';
import ModalComponent from 'components/ModalComponent';

import './styles/BillingImportJobForm.scss';


const BillingImportJobForm = ({ submitJob }) => {
  const [importFile, setImportFile] = useState();
  const [description, setDescription] = useState('');
  const [dryRun, setDryRun] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const formSubmit = (e) => {
    e.preventDefault();
    const proceed = !(typeof importFile === 'undefined' || description === '' || submitting);
    if (proceed) {
      setSubmitting(true);
      submitJob({ importFile, description, dryRun });
    }
  };

  const buttons = [
    <Button
      type='submit'
      variant={submitting ? 'secondary' : 'success'}
      disabled={(typeof importFile === 'undefined' || description === '' || submitting)}
      onClick={formSubmit}
    >
      {submitting ? 'Submitting...' : 'Submit Import'}
    </Button>
  ];

  return (
    <ModalComponent id='billing-import-job__modal' className='billing-import-job__modal' title={'Import Billing Transactions'} buttons={buttons}>
      <form className='form form-horizontal billing-import-job__form' method='post' onSubmit={formSubmit}>
        <Form.Group className='billing-import-job__form-group' controlId={'importFile'}>
          <Form.Label column sm={4}>
            Import Data
            &nbsp;
          </Form.Label>
          <Col sm={16}>
            <Form.Control onChange={(e) => setImportFile(e.target.files[0])} type='file' />
          </Col>
        </Form.Group>

        <Form.Group className='billing-import-job__form-group' controlId={'description'}>
          <Form.Label column sm={4}>Description&nbsp;</Form.Label>
          <Col sm={16}>
            <Form.Control size='sm' onChange={(e) => setDescription(e.target.value)} type='text' />
          </Col>
        </Form.Group>

        <Form.Group className='billing-import-job__form-group' controlId={'dryRun'}>
          <Form.Label column sm={4}>
            Validate Only?
            &nbsp;
          </Form.Label>
          <Col sm={16}>
            <Form.Check onChange={(e) => setDryRun(e.target.checked)} type='checkbox' />
          </Col>
        </Form.Group>
      </form>
    </ModalComponent>
  );
};

BillingImportJobForm.propTypes = {
  submitJob: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  submitJob: (importJob) => {
    dispatch(billingImportJobs.actions.create(importJob))
      .then(() => dispatch(modals.actions.hide()))
      .then(() => dispatch(billingImportJobs.actions.markDirty()))
      .catch(() => {
        dispatch(modals.actions.hide());
        dispatch(modals.actions.show('UnexpectedError'));
      });
  }
});

export default connect(() => ({}), mapDispatchToProps)(BillingImportJobForm);
